module.exports = (parcelRequire.load("4ZG16")).then(() => parcelRequire('hjNk0'));